module.exports = __webpack_public_path__ + "5a9e97c0c170c2df20216612a4857344.txt";